import {
  TARIFF_SEARCH_REQUEST_IDENTIFIER,
  TariffError,
} from '@/features/Tariffs/types';

export const tariffErrorOverride = (
  tariffError: TariffError,
  alternateTariffSearchRequestIdentifier?: TARIFF_SEARCH_REQUEST_IDENTIFIER,
) => {
  if (
    alternateTariffSearchRequestIdentifier ===
      TARIFF_SEARCH_REQUEST_IDENTIFIER.KFZ_AENDERUNGSANTRAG &&
    tariffError.insuranceId === 122 // Allianz
  ) {
    tariffError.fehlerbeschreibung = ['Änderungsantrag momentan nicht möglich'];
  }

  return tariffError;
};
